import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_lazy_load = _resolveComponent("lazy-load");
    const _component_q_item_section = _resolveComponent("q-item-section");
    const _component_q_chip = _resolveComponent("q-chip");
    const _component_q_item_label = _resolveComponent("q-item-label");
    const _component_q_item = _resolveComponent("q-item");
    const _component_q_list = _resolveComponent("q-list");
    const _component_general_dialog = _resolveComponent("general-dialog");
    return (_openBlock(), _createBlock(_component_general_dialog, {
        modelValue: _ctx.videoListDialogShow,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.videoListDialogShow) = $event)),
        title: "Video(s)",
        width: "500px",
        "full-screen": _ctx.$q.screen.width < 320,
        persistent: _ctx.styleType === 'desktop'
    }, {
        "content-sections": _withCtx(() => [
            _createElementVNode("div", null, [
                _createVNode(_component_q_list, { separator: "" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, (value, index) => {
                            return (_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                dense: "",
                                class: "q-pa-md",
                                key: index,
                                onClick: ($event) => (_ctx.showVideo(value))
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_lazy_load, {
                                                alt: value.content_type,
                                                url: value.thumbnail,
                                                class: "self-center",
                                                "pic-class": {
                                                    'video-image cursor-pointer': true
                                                },
                                                format: "jpg",
                                                "component-size": "160px",
                                                "force-ratio": "",
                                                side: ""
                                            }, null, 8, ["alt", "url"])
                                        ]),
                                        _: 2
                                    }, 1024),
                                    _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_q_item_label, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_chip, {
                                                        color: value.content_type === 'showcase' ? 'warning' : 'orange-8',
                                                        "text-color": value.content_type === 'showcase' ? 'grey-8' : 'white',
                                                        dense: "",
                                                        square: "",
                                                        class: "q-ma-none caption-lt-sm font-weight-bold-important"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.parseCamelCase(value.content_type)), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["color", "text-color"])
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createVNode(_component_q_item_label, {
                                                lines: "3",
                                                class: "caption-lt-sm font-weight-bold-important"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(value.caption), 1)
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 2
                            }, 1032, ["onClick"]));
                        }), 128))
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }, 8, ["modelValue", "full-screen", "persistent"]));
}
